<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="teal">
          <v-icon medium>edit</v-icon>
          <v-toolbar-title>ข้อมูลแผนการสอน {{ title.subject.label }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
             <v-container class="pa-0" fluid>
              <v-layout row wrap>
          
                <!-- PART I -->
                <v-flex d-flex xs12 md12>
                  <v-card color="grey lighten-5">
                    <v-toolbar dark class="title green lighten-2">
                      <v-toolbar-title>สัปดาห์ที่ {{ title.week }}</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="py-0">
                      <v-container class="px-0" grid-list-md text-xs-left>
                        <v-layout row wrap>
                          <v-flex xs12 md3>
                            <v-menu
                              :close-on-content-click="false"
                              v-model="menu"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                              :disabled="disabled"
                            >
                              <v-text-field
                                slot="activator"
                                :value="date(item.date)" 
                                label="วันที่สอน"
                                prepend-icon="event"
                                readonly
                                outline
                                :disabled="disabled"
                                hide-details
                              ></v-text-field>
                              <v-date-picker 
                                v-model="item.date" 
                                no-title 
                                locale="th-Th"
                                @input="menu = false"></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs12 md9>
                            <v-textarea
                              v-model="item.remark" 
                              label="หมายเหตุ"
                              rows="1"
                              outline
                              hide-details
                              :disabled="disabled"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>          
                  </v-card>
                </v-flex>
                
                <!-- PART II -->
                <v-flex d-flex xs12 md6>
                  <v-card color="grey lighten-5">
                    <v-toolbar dark class="title purple lighten-2">
                      <v-toolbar-title>บรรยาย</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="py-0">
                      <v-container class="px-0" grid-list-md text-xs-center>
                        <v-layout row wrap>
                          <v-flex xs12 md2>
                            <v-text-field type="number" label="ชั่วโมง" v-model="item.lectureHours" mask="#" outline hide-details :disabled="disabled"></v-text-field>
                          </v-flex>
                          <v-flex xs12 md10>
                            <v-textarea
                              v-model="item.lectureTitle" 
                              label="หัวข้อบรรยาย"
                              outline
                              rows="1"
                              hide-details
                              :disabled="disabled"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-container> 
                    </v-card-text>
                    <v-toolbar dark class="title purple lighten-2">
                      <v-toolbar-title>ผู้สอน/วิทยากร</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="py-0">
                      <v-container class="px-0" grid-list-md text-xs-center>
                        <v-layout row wrap>
                          <v-flex xs12 md12>
                            <v-card class="mb-3" v-for="(item, index) in item.lectureInstructors" :key="item.id">
                              <v-card-text class="py-0">
                                <v-layout>
                                  <instructor :disabled="disabled" :instructor="item" :index="index"></instructor>
                                  <v-btn icon class="pink--text" @click.native="removeRow(item, index)" v-if="!disabled">
                                    <v-icon small>close</v-icon>
                                  </v-btn>
                              </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 md12>
                            <v-btn @click.native="addRow" class="indigo white--text" v-if="!disabled">เพิ่มผู้สอน/วิทยากร</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container> 
                    </v-card-text>
                  </v-card>
                </v-flex>

                <!-- PART III -->
                <v-flex d-flex xs12 md6>
                  <v-card color="grey lighten-5">
                    <v-toolbar dark class="title deep-purple lighten-2">
                      <v-toolbar-title>กิจกรรม</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="py-0">
                      <v-container class="px-0" grid-list-md text-xs-center>
                        <v-layout row wrap>
                          <v-flex xs12 md2>
                            <v-text-field type="number" label="ชั่วโมง" v-model="item.groupHours" mask="#" outline disabled hide-details></v-text-field>
                          </v-flex>
                          <v-flex xs12 md10>
                            <v-textarea
                              v-model="item.groupTitle" 
                              label="หัวข้อกิจกรรม"
                              outline
                              rows="1"
                              :disabled="disabled"
                              hide-details
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-container> 
                    </v-card-text>
                    <v-toolbar dark class="title deep-purple lighten-2">
                      <v-toolbar-title>อาจารย์ที่ปรึกษา</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="py-0">
                      <v-container class="px-0" grid-list-md text-xs-center>
                        <v-layout row wrap>
                          <v-flex xs12 md12>
                            <v-card class="mb-3 grey lighten-5 elevation-0" v-for="(item, index) in item.groupInstructors" :key="item.id">
                              <v-card-text class="py-0">
                                <v-layout>
                                  <span class="orange--text ml-2"><strong>ประจำกลุ่มย่อย {{ item.subSectionName }}</strong></span> <span class="grey--text ml-2"><strong> {{ item.fullname }} </strong></span> 
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-container> 
                    </v-card-text>
                  </v-card>
                </v-flex>

              </v-layout>

              <!-- <v-layout class="mt-2">
                <v-btn dark color="grey" @click="close">ปิด</v-btn>
                <v-spacer></v-spacer>
                <v-btn dark color="green" @click="submit" :loading="loading" :disabled="!valid" v-if="!disabled">บันทึก</v-btn>
              </v-layout> -->
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn dark color="grey white--text" @click="close">ปิด</v-btn>
          <v-spacer></v-spacer>
          <v-btn dark color="success" @click="submit" :loading="loading" :disabled="!valid" v-if="!disabled">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import swal from 'sweetalert2'
import Instructor from './instructor.vue'

export default {
  props: ['dialog', 'item', 'title'],
  components: {
    Instructor
  },
  data () {
    return {
      loading: false,
      valid: false,
      menu: false,
    }
  },
  computed: {
    disabled () {
      return this.item.timesheets.length > 0 ? true : false
    }
  },
  mounted () {

  },
  methods: {
    addRow () {
      // console.log('addRow called...')
      this.item.lectureInstructors.push({
        person: null,
        guest: false,
        isParking: false,
        isPay: false,
        isLetter: false,
        authorizedPerson: null
      })
    },
    removeRow (item, index) {
      // console.log('item', item)
      if(item.id !== undefined) {
        // console.log('removeRow called...')
        this.removeInstructor(item, index)
      } else {
        this.item.lectureInstructors.splice(index, 1)
      }
    },
    removeInstructor (item, index) {
      const vm = this
      const data = {
        id: item.id,
        index: index,
        type: 'L'
      }
      swal({
        title: 'ยืนยันการลบข้อมูล',
        text: "หากลบแล้วจะไม่สามารถกู้คืนข้อมูลได้",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then(function () {
        vm.$store.dispatch('instructor/delete', data)
          .then((response) => {
            vm.item.lectureInstructors.splice(index, 1)
          }).catch((error)=>{
            console.log('reload', error)
          })
      })
    },
    addGroupInstructorRow () {
      // console.log('addGroupInstructorRow called...')
      this.item.groupInstructors.push({
        person: null,
        guest: false,
        isParking: false,
        isPay: false,
        isLetter: false,
        authorizedPerson: null
      })
    },
    removeGroupInstructorRow (item, index) {
      // console.log('item', item)
      if(item.id !== undefined) {
        // console.log('removeRow called...')
        this.removeGroupInstructor(item, index)
      } else {
        this.item.groupInstructors.splice(index, 1)
      }
    },
    removeGroupInstructor (item, index) {
      const vm = this
      const data = {
        id: item.id,
        index: index,
        type: 'L'
      }
      swal({
        title: 'ยืนยันการลบข้อมูล',
        text: "หากลบแล้วจะไม่สามารถกู้คืนข้อมูลได้",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then(function () {
        vm.$store.dispatch('instructor/delete', data)
          .then((response) => {
            vm.item.groupInstructors.splice(index, 1)
          }).catch((error)=>{
            console.log('reload', error)
          })
      })
    },
    clear () {
      this.$refs.form.reset()
    },
    close () {
      this.$emit('dialog', false)
      // this.clear()
    },
    date (val) {
      return this.$options.filters.formatFullDate(val)
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let dispatch = this.item.id && this.item.id > 0 ? 'coursePlan/update' : 'coursePlan/create'
        // console.log('dispatch', dispatch)
        this.$store.dispatch(dispatch, this.item)
          .then((response) => {
            // console.log('onSave:', response )
            this.loading = false
            swal({
              position: 'center',
              type: 'success',
              title: 'Your data has been saved',
              showConfirmButton: false,
              timer: 1500
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    },
    fetchPersons () {
      this.$store.dispatch("personType/loadItems")
        .then((response) => {
          this.personTypeItems = response.data
        }).catch((error)=>{
          console.log('reload', error)
          // swal('Error!', error.message, 'error')
        })
    }
  },
  watch: {
    menuBirthDate (val) {
      val && this.$nextTick(() => (this.$refs.pickerBirthDate.activePicker = 'YEAR'))
    },
    menuStartingDate (val) {
      val && this.$nextTick(() => (this.$refs.pickerStartingDate.activePicker = 'YEAR'))
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/coursePlan/forms/lgFormDialog.vue